export type LoginEmailCheckState = {
  exists: boolean;
  isPendingActivation?: boolean;
  tokenAtivacao?: string | null;
  statusConta?: string;
  hasDesktopPasskeys: boolean;
  hasMobileApproval: boolean;
  hasPushToken: boolean;
  canRequestMobileApproval: boolean;
  canSelfRegister?: boolean;
};

export function normalizeLoginEmailCheckResponse(payload: unknown): LoginEmailCheckState {
  const record = payload && typeof payload === 'object' ? payload as Record<string, unknown> : {};
  const exists = record.exists === true;
  const isPendingActivation = record.isPendingActivation === true;
  const tokenAtivacao = typeof record.tokenAtivacao === 'string' ? record.tokenAtivacao : null;
  const statusConta = typeof record.statusConta === 'string' ? record.statusConta : undefined;
  const hasDesktopPasskeys = exists && record.hasPasskeys === true;
  const hasMobileApproval = exists && record.hasMobileApproval === true;
  const hasPushToken = exists && record.hasPushToken === true;
  const canSelfRegister = record.canSelfRegister === true;

  return {
    exists,
    isPendingActivation,
    tokenAtivacao,
    statusConta,
    hasDesktopPasskeys,
    hasMobileApproval,
    hasPushToken,
    canRequestMobileApproval: hasMobileApproval && hasPushToken,
    canSelfRegister,
  };
}
